"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _base = _interopRequireDefault(require("../../style/themes/base"));

var _color = require("../../style/utils/color");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function () { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const pointerColor = (type, theme, bgColor) => {
  if (bgColor) return (0, _color.toColor)(theme, bgColor);
  return type === "error" ? theme.colors.error : theme.colors.black;
};

const StyledTooltipPointer = _styledComponents.default.div`
  ${({
  position,
  theme,
  type,
  bgColor
}) => (0, _styledComponents.css)`
    position: absolute;
    width: 0;
    height: 0;

    ${position === "top" && (0, _styledComponents.css)`
      border-left: 8px solid transparent;
      border-right: 8px solid transparent;
      border-top: 8px solid ${pointerColor(type, theme, bgColor)};
      bottom: -${theme.spacing}px;
      @-moz-document url-prefix() {
        bottom: -7px;
      }
    `}

    ${position === "bottom" && (0, _styledComponents.css)`
      border-left: 8px solid transparent;
      border-right: 8px solid transparent;
      border-bottom: 8px solid ${pointerColor(type, theme, bgColor)};
      top: -${theme.spacing}px;
      @-moz-document url-prefix() {
        top: -7px;
      }
    `}

    ${position === "right" && (0, _styledComponents.css)`
      border-top: 8px solid transparent;
      border-bottom: 8px solid transparent;
      border-right: 8px solid ${pointerColor(type, theme, bgColor)};
      left: -${theme.spacing}px;
      @-moz-document url-prefix() {
        left: -7px;
      }
    `}

    ${position === "left" && (0, _styledComponents.css)`
      border-top: 8px solid transparent;
      border-bottom: 8px solid transparent;
      border-left: 8px solid ${pointerColor(type, theme, bgColor)};
      right: -${theme.spacing}px;
      @-moz-document url-prefix() {
        right: -7px;
      }
    `}
  `}
`;
StyledTooltipPointer.defaultProps = {
  theme: _base.default,
  position: "top"
};
StyledTooltipPointer.propTypes = {
  position: _propTypes.default.oneOf(["bottom", "left", "right", "top"]),
  theme: _propTypes.default.object,
  type: _propTypes.default.string
};
var _default = StyledTooltipPointer;
exports.default = _default;